import React from 'react';

import CommonLargeModal from 'components/Modals/CommonLargeModal';
import ModalButton from 'components/ModalButton/ModalButton';

type RemoveExtraModalProps = {
  // The product's display name, which appears in the heading, the body copy and the CTA.
  productName: string;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Asks the member to confirm before a breakdown extra comes off their cover. The copy is
 * identical for every product, with only the name changing, so there is one modal rather
 * than per-product variants.
 */
const RemoveExtraModal = ({ productName, onConfirm, onCancel }: RemoveExtraModalProps) => (
  <CommonLargeModal
    show
    onHide={onCancel}
    title={(
      <>
        Are you sure you want to remove{' '}
        <span style={{ color: '#f95108' }}>{productName}</span>?
      </>
    )}
    titleClassName="font-bold-display fw-normal fs-3 lh-sm"
  >
    <p className="mb-4 fs-6 lh-sm">
      Removing <strong>{productName}</strong> means you won&apos;t be covered for it if you
      break down. You can add it back anytime.
    </p>
    <ModalButton
      type="button"
      variant="filled"
      onClick={onConfirm}
      data-testid="confirm-remove-extra"
    >
      Remove {productName}
    </ModalButton>
    <ModalButton
      type="button"
      variant="outline"
      onClick={onCancel}
      data-testid="cancel-remove-extra"
    >
      Cancel
    </ModalButton>
  </CommonLargeModal>
);

export default RemoveExtraModal;
